// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__lyGPt","insightsList":"newBusinessInsightsMenu_insightsList__2Gq91","active":"newBusinessInsightsMenu_active__ustTZ"};